import { RiskPoolCompliancePerformance, RiskPoolOrganization } from '../../_types/risk_pool';
import { randCity, randNumber } from '@ngneat/falso';
import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'risk_pool_mock_data';
const ORGANIZATIONS_STORAGE_KEY = 'risk_pool_organizations';

const randomInt = (min: number, max: number) => randNumber({ min, max });

const randomDepartmentType = () => {
  const types = ['PD', 'FD', 'Jail'];
  return types[Math.floor(Math.random() * types.length)];
};

const randomCompliancePerformance = (): RiskPoolCompliancePerformance => {
  const values: RiskPoolCompliancePerformance[] = ['compliant', 'partial', 'nonCompliant'];
  return values[Math.floor(Math.random() * values.length)];
};

const generateMockOrganization = (id: string, name: string, hasManualContent = true): RiskPoolOrganization => {
  const issuedPolicyCount = hasManualContent ? randomInt(0, 40) : 0;
  const draftPolicyCount = hasManualContent ? randomInt(30, 50) : 0;
  const modifiedPolicyPercentage = hasManualContent ? Math.round(Math.random() * 100) / 100 : 0;

  return {
    id,
    name,
    compliancePerformance: hasManualContent ? randomCompliancePerformance() : 'nonCompliant',
    issuedPolicyCount,
    draftPolicyCount,
    modifiedPolicyPercentage,
    hasManualContent,
  };
};

const generateAndStoreOrganizations = (): Array<{ id: string; name: string }> => {
  const organizations: Array<{ id: string; name: string }> = [];
  for (let i = 0; i < 10; i++) {
    organizations.push({ id: uuidv4(), name: `${randCity()} ${randomDepartmentType()}` });
  }
  sessionStorage.setItem(ORGANIZATIONS_STORAGE_KEY, JSON.stringify(organizations));
  return organizations;
};

export const getPersistentOrganizations = (): Array<{ id: string; name: string }> => {
  const stored = sessionStorage.getItem(ORGANIZATIONS_STORAGE_KEY);
  if (stored) return JSON.parse(stored);
  return generateAndStoreOrganizations();
};

const getStorageKey = (params: Record<string, any>) => `${STORAGE_KEY}_${params.date || 'today'}`;

const generateAndStoreMockData = (params: Record<string, any> = {}): RiskPoolOrganization[] => {
  const organizations = getPersistentOrganizations();
  // ~10% of orgs have no manual content (empty state)
  const noContentCount = Math.max(1, Math.round(organizations.length * 0.1));
  const mockData: RiskPoolOrganization[] = organizations.map((org, i) =>
    generateMockOrganization(org.id, org.name, i >= noContentCount)
  );
  sessionStorage.setItem(getStorageKey(params), JSON.stringify(mockData));
  return mockData;
};

const getMockData = (params: Record<string, any> = {}): RiskPoolOrganization[] => {
  const stored = sessionStorage.getItem(getStorageKey(params));
  if (stored) return JSON.parse(stored);
  return generateAndStoreMockData(params);
};

export const generateRiskPoolMetrics = (orgId: string, params: Record<string, any> = {}): RiskPoolOrganization[] =>
  getMockData(params);
